import * as React from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import ListDocuments from "./ListDocuments";
import ListDocumentsActions from "./ListDocumentsActions";
import ModalDocumentManagement from "./ModalDocumentManagement";
import classnames from 'classnames';
import Spinner from 'react-bootstrap/Spinner';
import ListSourceDocuments from './ListSourceDocuments';
import ListSourceDocumentsActions from './ListSourceDocumentsActions';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const DocumentManagement = ({ location }) => {

    //Tipos de Archivos
    const [informedConsents, setInformedConsents] = React.useState([]);
    const [studyQuestionaries, setStudyQuestionaries] = React.useState([]);
    const [labManuals, setLabManuals] = React.useState([]);
    const [investingManuals, setInvestingManuals] = React.useState([]);
    const [recruitmentMaterial, setRecruitmentMaterial] = React.useState([]);
    const [protocols, setProtocols] = React.useState([]);
    const [sourceDocuments, setSourceDocuments] = React.useState([]);

    //Componente
    const [openModal, setOpenModal] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState('1');
    const [isLoading,setIsLoading] = React.useState(false);
    const history = useHistory();
    let feasibility = location.state;

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: feasibility
        });
    }

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const listarDocumentos = async () => {
        setIsLoading(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}gestion-documental/list?id_estudio=${location.state.id_estudio}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            GroupClassDocuments(data);
        }).catch(err => {
            CleanDocuments();
        });
    }

    const listarDocumentosFuente = async () => 
    {
        //setIsLoading(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}archivos/consultar-por-estudio?id_estudio=${location.state.id_estudio}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setSourceDocuments(data);
            //setIsLoading(false);
        }).catch(err => {
            setSourceDocuments([]);
            //setIsLoading(false);
        });
    }

    const GroupClassDocuments = (docs) => {
        filterInformedConsents(docs);
        filterStudyQuestionaries(docs);
        filterLabManuals(docs);
        filterInvestingManuals(docs);
        filterRecruitmentMaterial(docs);
        filterProtocols(docs);
        setIsLoading(false);
    }

    const filterInformedConsents = (docs) => {
        let docsInformedConsents = docs.filter(doc => doc.clase == 1);
        let documentActive = docsInformedConsents.find(doc => doc.estado == 1);
        if(documentActive != null && documentActive != undefined) 
        {
            for(let i = 0; i < docsInformedConsents.length; i++)
            {
                if(docsInformedConsents[i].id_est_gestd > documentActive.id_est_gestd)
                {
                    docsInformedConsents[i].editable = true;
                }
                else
                {
                    docsInformedConsents[i].editable = false;
                }
            }
        }
        else
        {
            for(let i = 0; i < docsInformedConsents.length; i++)
            {
                docsInformedConsents[i].editable = true;
            }
        }
        setInformedConsents(docsInformedConsents);
    }

    const filterStudyQuestionaries = (docs) => {
        let docsStudyQuestionaries = docs.filter(doc => doc.clase == 2);
        let documentActive = docsStudyQuestionaries.find(doc => doc.estado == 1);
        if(documentActive != null && documentActive != undefined) 
        {
            for(let i = 0; i < docsStudyQuestionaries.length; i++)
            {
                if(docsStudyQuestionaries[i].id_est_gestd > documentActive.id_est_gestd)
                {
                    docsStudyQuestionaries[i].editable = true;
                }
                else
                {
                    docsStudyQuestionaries[i].editable = false;
                }
            }
        }
        else
        {
            for(let i = 0; i < docsStudyQuestionaries.length; i++)
            {
                docsStudyQuestionaries[i].editable = true;
            }
        }
        setStudyQuestionaries(docsStudyQuestionaries);
    }

    const filterLabManuals = (docs) => {
        let docsLabManuals = docs.filter(doc => doc.clase == 3);
        let documentActive = docsLabManuals.find(doc => doc.estado == 1);
        if(documentActive != null && documentActive != undefined) 
        {
            for(let i = 0; i < docsLabManuals.length; i++)
            {
                if(docsLabManuals[i].id_est_gestd > documentActive.id_est_gestd)
                {
                    docsLabManuals[i].editable = true;
                }
                else
                {
                    docsLabManuals[i].editable = false;
                }
            }
        }
        else
        {
            for(let i = 0; i < docsLabManuals.length; i++)
            {
                docsLabManuals[i].editable = true;
            }
        }
        setLabManuals(docsLabManuals);
    }

    const filterInvestingManuals = (docs) => {
        let docsInvestingManuals = docs.filter(doc => doc.clase == 4);
        let documentActive = docsInvestingManuals.find(doc => doc.estado == 1);
        if(documentActive != null && documentActive != undefined) 
        {
            for(let i = 0; i < docsInvestingManuals.length; i++)
            {
                if(docsInvestingManuals[i].id_est_gestd > documentActive.id_est_gestd)
                {
                    docsInvestingManuals[i].editable = true;
                }
                else
                {
                    docsInvestingManuals[i].editable = false;
                }
            }
        }
        else
        {
            for(let i = 0; i < docsInvestingManuals.length; i++)
            {
                docsInvestingManuals[i].editable = true;
            }
        }
        setInvestingManuals(docsInvestingManuals);
    }

    const filterRecruitmentMaterial = (docs) => {
        let docsRecruitmentMaterial = docs.filter(doc => doc.clase == 5);
        let documentActive = docsRecruitmentMaterial.find(doc => doc.estado == 1);
        if(documentActive != null && documentActive != undefined) 
        {
            for(let i = 0; i < docsRecruitmentMaterial.length; i++)
            {
                if(docsRecruitmentMaterial[i].id_est_gestd > documentActive.id_est_gestd)
                {
                    docsRecruitmentMaterial[i].editable = true;
                }
                else
                {
                    docsRecruitmentMaterial[i].editable = false;
                }
            }
        }
        else
        {
            for(let i = 0; i < docsRecruitmentMaterial.length; i++)
            {
                docsRecruitmentMaterial[i].editable = true;
            }
        }
        setRecruitmentMaterial(docsRecruitmentMaterial);
    }

    const filterProtocols = (docs) => {
        let docsProtocols = docs.filter(doc => doc.clase == 6);
        let documentActive = docsProtocols.find(doc => doc.estado == 1);
        if(documentActive != null && documentActive != undefined) 
        {
            for(let i = 0; i < docsProtocols.length; i++)
            {
                if(docsProtocols[i].id_est_gestd > documentActive.id_est_gestd)
                {
                    docsProtocols[i].editable = true;
                }
                else
                {
                    docsProtocols[i].editable = false;
                }
            }
        }
        else
        {
            for(let i = 0; i < docsProtocols.length; i++)
            {
                docsProtocols[i].editable = true;
            }
        }
        setProtocols(docsProtocols);
    }



    const CleanDocuments = () => {
        setInformedConsents([]);
        setStudyQuestionaries([]);
        setLabManuals([]);
        setInvestingManuals([]);
        setRecruitmentMaterial([]);
        setProtocols([]);
        setIsLoading(false);
    }

    const DocumentList = ({ data }) => {
        return (
            <div className="text-center">
                {isLoading ? <div>
                    <Spinner animation="border" variant="success" />
                </div> : <ListDocuments
                    reactTableData={data}
                    id_estudio={location.state.id_estudio}
                    ReactTableActions={ListDocumentsActions}
                    refreshList={listarDocumentos}
                />}
            </div>
        );
    }

    const SourceDocumentList = ({ data }) => {
        return (
            <div className="text-center">
                {isLoading ? <div>
                    <Spinner animation="border" variant="success" />
                </div> : <ListSourceDocuments
                    reactTableData={data}
                    id_estudio={location.state.id_estudio}
                    ReactTableActions={ListSourceDocumentsActions}
                />}
            </div>
        );
    }

    React.useEffect(() => {
        listarDocumentos();
        listarDocumentosFuente();
    }, []);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Gestión Documental</h3>
                    <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>
                    
                    <Col md={2}>
                        <div className='top_info_buttons_hc'>
                            <div>
                                <Tooltip
                                    title="Regresar al Dashboard"
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            regresar();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                                <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <Row>
                        <div className="text-center">
                            {
                                <Button onClick={() => setOpenModal(true)} className="btn btn-primary btn-sm text-white">
                                    Agregar
                                </Button>
                            }
                        </div>
                        <Container>
                            <div className="tabs tabs--justify tabs--bordered-top">
                                <div className="tabs__wrap">
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => toggle('1')}
                                            >
                                                Consentimiento Informado
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => toggle('2')}
                                            >
                                                Cuestionarios del Estudio
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '3' })}
                                                onClick={() => toggle('3')}
                                            >
                                                Manuales de Laboratorio
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '4' })}
                                                onClick={() => toggle('4')}
                                            >
                                                Manuales de Investigación
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '5' })}
                                                onClick={() => toggle('5')}
                                            >
                                                Material de Reclutamiento
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '6' })}
                                                onClick={() => toggle('6')}
                                            >
                                                Protocolos del Estudio Clinico
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '7' })}
                                                onClick={() => toggle('7')}
                                            >
                                                Documentos Fuente del Estudio
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <div className="text-center">
                                                <DocumentList data={informedConsents} toggle={toggle} />
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <div className="text-center">
                                                <DocumentList data={studyQuestionaries} toggle={toggle} />
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <div className="text-center">
                                                <DocumentList data={labManuals} toggle={toggle} />
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <div className="text-center">
                                                <DocumentList data={investingManuals} toggle={toggle} />
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <div className="text-center">
                                                <DocumentList data={recruitmentMaterial} toggle={toggle} />
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="6">
                                            <div className="text-center">
                                                <DocumentList data={protocols} toggle={toggle} />
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="7">
                                            <div className="text-center">
                                                <SourceDocumentList data={sourceDocuments}/>
                                            </div>
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </Container>
                    </Row>
                </CardBody>

                <ModalDocumentManagement
                    openModal={openModal}
                    closeModal={() => setOpenModal(false)}
                    id_estudio={location.state.id_estudio}
                    listarDocumentos={listarDocumentos}
                    documentInformation={null}
                    toggle={toggle}
                />
            </Card>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_criterial_excinc', // a unique identifier for this form
})(DocumentManagement);